<template>
	<div class="order-summary-item" :class="{counter: isInCounter}">
		<div class="item-container" @click="toggleEdit">
			<div class="image-container">
				<img :src="image">
			</div>
			<div class="item-info" :class="{deletable}">
				<div class="item-name">{{ title }}</div>
				<div class="item-info-data">
					<div class="item-quantity" v-if="quantity">{{ itemQuantity }}</div>
					<div class="item-quantity" v-else></div>
					<div class="item-price">{{ itemTotal }}</div>
				</div>
			</div>
			<div v-if="deletable" class="item-delete" @click.stop="changedQuantity(quantity ? quantity-1 : 0)">
				<img :src="'https://img.qromo.io/img/icons/icon-bin-counter-blue'+(userStore.darkMode ? '-dark' : '')+'.svg'">
			</div>
		</div>
		<BottomFakeItemEditor :active="editItem" :title="getString('fake_item')" :quantity="quantity" :price="price" @toggling-popup="togglingPopup" @changed-price="changedPrice" @changed-quantity="changedQuantity" />
	</div>
</template>

<script>
import {useCurrencyStore, useLanguageStore} from "@/shared/stores";
import BottomFakeItemEditor from "@/console-new/components/ops/counter/BottomFakeItemEditor.vue";
import {useUserStore} from "@/console-new/stores/user.store";
export default {
	setup() {
		const languageStore = useLanguageStore();
		let userStore = useUserStore();
		const currencyStore = useCurrencyStore();
		return {
			getString: languageStore.getString,
			languageStore,
			currencyStore,
			userStore
		}
	},
	name: "OrderSummaryItemFake",
	emits: ["changed-price", "changed-quantity"],
	components: {BottomFakeItemEditor},
	data() {
		return {
			editItem: false,
		}
	},
	props: {
		title: {
			type: String,
			default: "-"
		},
		price: {
			type: Number,
		},
		quantity: {
			type: Number,
			default: null
		},
		deletable: {
			type: Boolean,
			default: false
		},
		image: {
			type: String,
			default: "https://img.qromo.io/img/icons/icon-fake-product.svg"
		},
		isInCounter: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		itemTotal() {
			let quantity = this.quantity ? this.quantity : 1;
			return this.currencyStore.readableCurrencyValue(this.price*quantity);
		},
		itemQuantity() {
			return "x"+this.quantity;
		},
	},
	methods: {
		togglingPopup(isOpen) {
			if(!isOpen) {
				this.editItem = false;
			}
		},
		changedPrice(price) {
			this.$emit("changed-price", price);
		},
		changedQuantity(quantity) {
			this.$emit("changed-quantity", quantity);
		},
		toggleEdit() {
			if(this.deletable) {
				this.editItem = true;
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.order-summary-item {
	display: flex;
	flex-direction: column;
	width: 100%;

	&.counter {
		background-color: var(--color-bg);
	}

	.item-container {
		display: flex;
		align-items: stretch;
		justify-content: space-between;
		cursor: pointer;

		* {
			user-select: none;
		}

		.image-container {
			width: 45px;
			height: 45px;
			border-radius: 13px;
			margin-right: 10px;
			background-color: var(--color-bg-item);

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				border-radius: 13px;
			}
		}

		.item-info {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			width: calc(100% - 55px);

			.item-name {
				font-size: 16px;
				font-weight: 700;
				color: var(--color-txt);
				margin-bottom: 4px;
				@include truncateString();
			}

			.item-info-data {
				display: flex;
				justify-content: space-between;
				align-items: flex-end;
				width: 100%;

				.item-quantity {
					font-size: 16px;
					color: var(--color-primary);
				}

				.item-price {
					font-size: 14px;
					color: var(--color-txt);

					.item-price-discount {
						font-size: 12px;
						color: var(--color-txt-1);
						text-decoration: line-through;
						margin-right: 4px;
					}
				}
			}

			&.deletable {
				width: calc(100% - 83px);
			}
		}

		.item-delete {
			width: 20px;
			overflow: hidden;
			display: flex;
			justify-content: center;
			align-items: center;
			margin-left: 8px;
			cursor: pointer;

			img {
				width: 100%;
				padding: 3px;
			}
		}
	}

	.item-products-container {
		display: flex;
		flex-direction: column;
		width: calc(100% - 45px);
		margin-top: 8px;
		margin-left: 45px;
		padding: 8px 10px;
		background-color: var(--color-alpha-1);
		box-shadow: inset 0 2px 3px var(--color-box-shadow-2);
		border-radius: 13px;

		.item-product {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			width: 100%;

			&::after {
				content: "";
				display: block;
				width: 100%;
				height: 1px;
				background-color: var(--color-box-shadow-1);
				margin-top: 6px;
				margin-bottom: 6px;
			}

			.item-product-name {
				font-size: 14px;
				color: var(--color-txt);
				@include truncateString();
			}

			.item-product-info-data {
				display: flex;
				justify-content: space-between;
				align-items: flex-end;
				width: 100%;
				margin-top: 2px;

				.item-product-quantity {
					font-size: 14px;
					color: $primary;
				}

				.item-product-price {
					font-size: 14px;
					color: var(--color-txt);
				}
			}
		}

		.item-product:last-child {
			&::after {
				content: none;
			}
		}
	}

	.notes-container {
		margin-top: 8px;

		.notes-title {
			font-size: 14px;
			color: var(--color-txt);
			font-weight: 700;
		}

		.notes-body {
			font-size: 14px;
			color: var(--color-txt);
			white-space: pre-wrap;
			word-wrap: break-word;
		}
	}

	.ghost-image-placeholder {
		width: 45px;
		height: 45px;
		background-color: var(--color-alpha-4);
		border-radius: 13px;
	}

	.ghost-placeholder {
		width: 60px;
		height: 18px;
		background-color: $alpha_1;
		border-radius: 4px;

		&.long {
			width: 110px;
		}

		&.short {
			width: 40px;
		}
	}

}
</style>